
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import AddIcon from '@mui/icons-material/Add';
import { Autocomplete, Checkbox, IconButton, ListItem, ListItemText, Stack, TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Form, Formik, getIn } from 'formik';
import { Close } from '@mui/icons-material';
import { baseUrl } from '../../utils/baseUrl';
import { useCreateConnectionMutation } from '../../Slices/roomNateApis';
import { ErrorAlert, SuccessAlert } from '../../utils/Alerts';
import { LoadingButton } from '@mui/lab';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: "90%",
    overflowY: "auto",
    width: { xs: '90%', md: "650px" },
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function BasicModal({ items, connectionPointsData, connectionPointsOptionsData }) {
    const [load, setLoad] = React.useState(false)

    const [createConnection, resultStats] = useCreateConnectionMutation()

    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);

    const ref = React.useRef()
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    React.useEffect(() => {
        if (resultStats?.isLoading) {
            setLoad(true)
        }

        if (!resultStats?.isLoading) {
            setLoad(false)
        }

        if (resultStats?.isSuccess) {
            setSuccessAlert(true)
            setTimeout(() => {
                setSuccessAlert(false)
            }, 2000);
            handleClose()
        }

        if (resultStats?.isError) {
            setErrorAlert(true)
            setTimeout(() => {
                setErrorAlert(false)
            }, 2000);

        }
    }, [resultStats])

    return (
        <>
            {successAlert &&
                <SuccessAlert title="Connection has been created successfully!" />
            }

            {errorAlert &&
                <ErrorAlert title="Something Went Wrong!" />
            }

            <Button onClick={handleOpen} variant="outlined" endIcon={<AddIcon />}>Add Points</Button>
            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box position="fixed" top={10} right={0}>
                        <IconButton onClick={handleClose}>
                            <Close />
                        </IconButton>
                    </Box>
                    <Formik
                        innerRef={ref}
                        initialValues={{
                            item1: items?.[0],
                            item2: [],
                            north: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7
                            },
                            south: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7
                            },
                            east: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7

                            },
                            west: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7

                            },
                            northwest: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7

                            },
                            northeast: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7

                            },
                            southwest: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7

                            },
                            southeast: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7

                            },
                            center: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7
                            },
                            top: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7
                            },
                            bottom: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7

                            },
                            cce: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7

                            },
                            ccw: {
                                north: 7,
                                south: 7,
                                east: 7,
                                west: 7,
                                northwest: 7,
                                northeast: 7,
                                southeast: 7,
                                southwest: 7,
                                center: 7,
                                top: 7,
                                bottom: 7,
                                cce: 7,
                                ccw: 7

                            }
                        }}
                        onSubmit={(values) => {
                            const { east, south, southeast, southwest, north, west, northeast, northwest, top, bottom, center, cce, ccw, item1, item2 } = values;
                            let updateItem1 = item1?._id;
                            let updateData;

                            for (let i = 0; i < item2.length; i++) {
                                updateData = {
                                    east,
                                    south,
                                    southeast,
                                    southwest,
                                    north,
                                    west,
                                    northeast,
                                    northwest,
                                    top,
                                    bottom,
                                    center,
                                    cce,
                                    ccw,
                                    item1: updateItem1,
                                    item2: item2[i]._id,
                                };
                                createConnection(updateData);
                            }
                        }}
                    >
                        {({ values, touched, errors, handleBlur, setValues }) => (
                            <Form noValidate autoComplete="off" >
                                <Typography id="modal-modal-title" variant='h6' mb={2}>
                                    Add Connection Points
                                </Typography>

                                {items &&
                                    <Stack mt={2}>
                                        <Autocomplete
                                            disablePortal
                                            onChange={(_, value) => setValues({ ...values, item1: (value || value == "") && value || items?.[0] })}
                                            name="item1"
                                            id="combo-box-demo"
                                            value={values?.item1}
                                            options={items}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField placeholder='Select item1' name='item1' {...params} label="Item1"
                                                onBlur={handleBlur}
                                                helperText={
                                                    getIn(touched, "item1") && getIn(errors, "item1")
                                                        ? getIn(errors, "item1")
                                                        : ""
                                                }
                                                error={Boolean(getIn(touched, "item1") && getIn(errors, "item1"))}
                                            />
                                            }
                                        />
                                    </Stack>
                                }

                                {items && values?.item1 &&
                                    <Stack mt={2}>
                                        <Autocomplete
                                            onChange={(_, value) => setValues({ ...values, item2: value })}
                                            required
                                            name="item2"
                                            multiple
                                            id="checkboxes-tags-demo"
                                            options={items?.filter((item) => item._id != values?.item1._id)}
                                            disableCloseOnSelect
                                            getOptionLabel={(option) => option.name}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props} key={option._id}>
                                                    <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selected}
                                                    />
                                                    {option.name}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField {...params} name="item2" label="Items" placeholder="Select Items" onBlur={handleBlur}
                                                    helperText={
                                                        getIn(touched, "item2") && getIn(errors, "item2")
                                                            ? getIn(errors, "item2")
                                                            : ""
                                                    }
                                                    error={Boolean(getIn(touched, "item2") && getIn(errors, "item2"))}
                                                />
                                            )}
                                        />
                                    </Stack>
                                }

                                {values?.item1 &&
                                    <Stack justifyContent={"space-between"} flexDirection="row" mt={2}>
                                        <Stack>
                                            <Box>
                                                <img src={`${baseUrl}/g${values?.item1?.frontViewImage
                                                    }`} alt={values?.item1?.name} height="100px" />
                                            </Box>
                                        </Stack>
                                    </Stack>
                                }

                                {values?.item2?.length >= 1 &&
                                    values?.item2?.map((item, _) => {
                                        return (
                                            <Stack justifyContent={"space-between"} flexDirection="row" mt={2}>
                                                <Stack>
                                                    <Box>
                                                        <img src={`${baseUrl}/g${item.frontViewImage}`} alt={item?.name} height="100px" />
                                                    </Box>
                                                </Stack>
                                            </Stack>
                                        )
                                    }
                                    )}

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>North Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, north: {
                                                                    ...values?.north, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.north[item.value])}
                                                            name={`north`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`north`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "north") && getIn(errors, "north")
                                                                        ? getIn(errors, "north")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "north") && getIn(errors, "north"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>South Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(event, value) => setValues({
                                                                ...values, south: {
                                                                    ...values?.south, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.south[item.value])}
                                                            name={`south`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`south`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "south") && getIn(errors, "south")
                                                                        ? getIn(errors, "south")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "south") && getIn(errors, "south"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>East Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, east: {
                                                                    ...values?.east, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.east[item.value])}
                                                            name={`east`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`east`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "east") && getIn(errors, "east")
                                                                        ? getIn(errors, "east")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "east") && getIn(errors, "east"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>West Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, west: {
                                                                    ...values?.west, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.west[item.value])}
                                                            name={`west`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`west`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "west") && getIn(errors, "west")
                                                                        ? getIn(errors, "west")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "west") && getIn(errors, "west"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>North West Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, northwest: {
                                                                    ...values?.northwest, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.northwest[item.value])}
                                                            name={`northwest`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`northwest`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "northwest") && getIn(errors, "northwest")
                                                                        ? getIn(errors, "northwest")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "northwest") && getIn(errors, "northwest"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>North East Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, northeast: {
                                                                    ...values?.northeast, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.northeast[item.value])}
                                                            name={`northeast`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`northeast`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "northeast") && getIn(errors, "northeast")
                                                                        ? getIn(errors, "northeast")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "northeast") && getIn(errors, "northeast"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>South West Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, southwest: {
                                                                    ...values?.southwest, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.southwest[item.value])}
                                                            name={`southwest`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`southwest`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "southwest") && getIn(errors, "southwest")
                                                                        ? getIn(errors, "southwest")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "southwest") && getIn(errors, "southwest"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>South East Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, southeast: {
                                                                    ...values?.southeast, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.southeast[item.value])}
                                                            name={`southeast`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`southeast`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "southeast") && getIn(errors, "southeast")
                                                                        ? getIn(errors, "southeast")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "southeast") && getIn(errors, "southeast"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>Center Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, center: {
                                                                    ...values?.center, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.center[item.value])}
                                                            name={`center`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`center`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "center") && getIn(errors, "center")
                                                                        ? getIn(errors, "center")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "center") && getIn(errors, "center"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>Top Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, top: {
                                                                    ...values?.top, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.top[item.value])}
                                                            name={`top`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`top`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "top") && getIn(errors, "top")
                                                                        ? getIn(errors, "top")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "top") && getIn(errors, "top"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>Bottom Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, bottom: {
                                                                    ...values?.bottom, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.bottom[item.value])}
                                                            name={`bottom`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`bottom`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "bottom") && getIn(errors, "bottom")
                                                                        ? getIn(errors, "bottom")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "bottom") && getIn(errors, "bottom"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>Center point between Center and East Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, cce: {
                                                                    ...values?.cce, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.cce[item.value])}
                                                            name={`cce`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`cce`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "cce") && getIn(errors, "cce")
                                                                        ? getIn(errors, "cce")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "cce") && getIn(errors, "cce"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2?.length >= 1 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>Center point between Center and East Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, ccw: {
                                                                    ...values?.ccw, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsData?.find((item) => item.value === values?.ccw[item.value])}
                                                            name={`ccw`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`ccw`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "ccw") && getIn(errors, "ccw")
                                                                        ? getIn(errors, "ccw")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "ccw") && getIn(errors, "ccw"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                <Stack mt={2}>
                                    <LoadingButton loading={load} variant="contained" fullWidth type="submit">
                                        Add
                                    </LoadingButton>
                                </Stack>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Modal >
        </>
    );
}

